// RTK Query slice for Golden Tickets
import { createApi } from "@reduxjs/toolkit/query/react";
import { dynamicBaseQuery } from "./baseQuery";

export const goldenTicketsApi = createApi({
  reducerPath: "goldenTicketsApi",
  baseQuery: dynamicBaseQuery,
  refetchOnFocus: false,
  refetchOnReconnect: false,
  keepUnusedDataFor: 300,
  tagTypes: ["GoldenTickets"],
  endpoints: (builder) => ({
    // Get all golden tickets for the current restaurant
    getGoldenTickets: builder.query({
      query: () => ({
        url: "api/golden-tickets",
        method: "GET",
        headers: { "Cache-Control": "no-cache" },
      }),
      transformResponse: (response) => ({
        tickets: response.tickets || [],
        stats: response.stats || {
          assigned: 0,
          maxAllowed: 3,
          remainingSlots: 3,
          canClaimMore: true,
          availableInPool: 0,
        },
        restaurantId: response.restaurantId,
      }),
      providesTags: ["GoldenTickets"],
    }),

    // Claim a golden ticket from the pool
    claimGoldenTicket: builder.mutation({
      query: () => ({
        url: "api/golden-tickets/claim",
        method: "POST",
      }),
      invalidatesTags: ["GoldenTickets"],
    }),

    // Give a golden ticket to someone
    giveGoldenTicket: builder.mutation({
      query: ({ ticketNumber, email, name }) => ({
        url: `api/golden-tickets/${ticketNumber}/give`,
        method: "PUT",
        body: { email, name },
      }),
      invalidatesTags: ["GoldenTickets"],
    }),

    // Redeem a golden ticket (for new restaurant signup)
    redeemGoldenTicket: builder.mutation({
      query: ({ code }) => ({
        url: "api/golden-tickets/redeem",
        method: "POST",
        body: { code },
      }),
      invalidatesTags: ["GoldenTickets"],
    }),

    // Get golden ticket stats (admin)
    getGoldenTicketStats: builder.query({
      query: () => ({
        url: "api/golden-tickets/stats",
        method: "GET",
      }),
      providesTags: ["GoldenTickets"],
    }),
  }),
});

export const {
  useGetGoldenTicketsQuery,
  useClaimGoldenTicketMutation,
  useGiveGoldenTicketMutation,
  useRedeemGoldenTicketMutation,
  useGetGoldenTicketStatsQuery,
} = goldenTicketsApi;
